@if (hideShell()) {
  <router-outlet />
} @else {
  <cmi-page-header />

  <div class="p-4 flex-1 overflow-auto">
    <router-outlet />
  </div>
}
